<template>
    <RedesignBaseModal
        data-testid="global-confirm-modal"
        :visible="isOpen"
        :width="MODAL_WIDTH"
        wrapper-classes="confirm-modal"
        append-to-body
        @close="closeModal"
    >
        <template #title>
            <div 
                data-testid="confirm-modal-title"
                class="text-xl font-semibold main-text-color confirm-modal-title"
            >
                {{ header || defaultHeader }}
            </div>
        </template>
        <div class="my-8 flex flex-col items-center justify-center">
            <div
                v-if="confirmModalState.descriptionIcon"
                class="mb-5"
            >
                <RedesignBaseIcon
                    :name="confirmModalState.descriptionIcon"
                    :size="64"
                    class="w-16 h-16 text-secondary-actions"
                />
            </div>
            <div 
                data-testid="confirm-modal-message"
                class="text-center main-text-color text-base max-w-65-p break-normal"
            >
                {{ message || defaultDescription }}
            </div>
        </div>
        <template #footer>
            <div class="w-full flex items-center justify-between">
                <RedesignBaseButton
                    data-testid="confirm-modal-cancel-button"
                    type="outline"
                    color="secondary"
                    icon="X"
                    @click="closeModal"
                >
                    {{ $t('common.cancel') }}
                </RedesignBaseButton>
                <RedesignBaseButton
                    data-testid="confirm-modal-confirm-button"
                    :color="currentTypeData.color"
                    :icon="currentTypeData.iconConfirm"
                    @click="confirm"
                >
                    {{ currentTypeData.action }}
                </RedesignBaseButton>
            </div>
        </template>
    </RedesignBaseModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { confirmModalState, ConfirmServiceTypeType } from '@/composables/useConfirmModal'
import i18n from '@/i18n'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import { TButtonColor } from '@/components/RedesignBaseComponents/Buttons/buttons'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import RedesignBaseModal from '@/components/RedesignComponents/Modal/RedesignBaseModal.vue'

const MODAL_WIDTH = '456px'

const MODAL_DATA_DEFAULT: Record<ConfirmServiceTypeType, { color: TButtonColor,iconConfirm: string, action: string  }> = {
    confirm: {
        color: 'primary',
        iconConfirm: 'Check',
        action: String(i18n.t('common.confirm'))
    },
    save: {
        color: 'primary',
        iconConfirm: 'Save',
        action: String(i18n.t('common.save'))
    },
    edit: {
        color: 'primary',
        iconConfirm: 'Check',
        action: String(i18n.t('common.confirm'))
    },
    delete: {
        color: 'destructive',
        iconConfirm: 'vc-icon-recycle-bin',
        action: String(i18n.t('common.delete'))
    }
}

const currentTypeData = computed(() => {
    const _type = confirmModalState.value.type as ConfirmServiceTypeType
    return MODAL_DATA_DEFAULT[_type] || MODAL_DATA_DEFAULT.confirm
})

const isOpen = computed(() => {
    return confirmModalState.value.open
})
const header = computed(() => {
    return confirmModalState.value.header
})
const message = computed(() => {
    return confirmModalState.value.message
})
const defaultHeader = computed(() => {
    return i18n.t('general.defaultConfirmation')
})
const defaultDescription = computed(() => {
    return i18n.t('dialog.confirm.description')
})

const emit = defineEmits([ 'close', 'confirm' ])

const closeModal = () => {
    if (confirmModalState.value.onClose !== undefined) {
        confirmModalState.value.onClose()
    }

    emit('close')
}
const confirm = () => {
    if (confirmModalState.value.onConfirm !== undefined) {
        confirmModalState.value.onConfirm()
    }
    emit('confirm')
}
</script>

<style lang="scss">

</style>
